/**
 * The Ably channel prefix this bundle uses, from the two places one can come from.
 *
 * The harness global wins, and only in a build made for E2E: a page script cannot re-prefix a
 * deployed bundle's channels. Otherwise the value compiled in through `VITE_ABLY_CHANNEL_NAMESPACE`,
 * which a preview environment sets to `pr-<n>`. Blank means no prefix.
 */
export function readAblyChannelNamespace(
  isE2EBuild: boolean,
  builtNamespace: string | undefined,
): string | undefined {
  const harness = globalThis as typeof globalThis & {
    __ATTORNEY_HUB_E2E_ABLY_NAMESPACE__?: string;
  };
  const fromHarness = isE2EBuild
    ? harness.__ATTORNEY_HUB_E2E_ABLY_NAMESPACE__?.trim()
    : undefined;
  if (fromHarness) return fromHarness;

  return builtNamespace?.trim() || undefined;
}
